export const ConfigKey_FHIRQueryResources_Key = 'fhir-query-resources';
//# sourceMappingURL=consts.js.map